/**
 * @param dataWrapper {ReturnType<import('core/data/data-wrapper')._DB>}
 */
export function createFNAConfigurationRepository(dataWrapper) {
  const { get } = dataWrapper

  const _getFNAConfiguration = (get) => get('fna-configuration')
  const getFNAConfiguration = () => _getFNAConfiguration(get)

  return {
    _getFNAConfiguration,
    getFNAConfiguration,
  }
}
